export const getProjectDetailsPath = (projectId: number): string => {
    return `/projects/${projectId}`;
};

export const PAGE_SIZE = 40;
